import { safeDecodeURI } from "../../common/common_tools";

// The `{{#N}}` markers inside the question text are the source of truth for a
// DragDrop question: their document order gives each slot, and N-1 is the
// answer index expected there. The exercise's stored `correctAnswer` is only
// the plugin default (`[0]`) — nothing ever writes the real mapping into it —
// so every consumer (visor rendering, scoring, see-answer) derives it here.
export function getDndCorrectAnswer(boxId, boxes, toolbars) {
  try {
    const qc = boxes[boxId].sortableContainers["sc-Question"];
    const qid = qc && qc.children && qc.children[0];
    const text = safeDecodeURI(
      (qid && toolbars[qid] && toolbars[qid].state && toolbars[qid].state.__text) || ""
    );
    const matches = text.match(/\{\{#(\d+)\}\}/g);
    if (matches) return matches.map((m) => parseInt(m.match(/\d+/)[0], 10) - 1);
  } catch (e) {
    /* fall through */
  }
  return [];
}
